<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {
    };
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Nunito+Sans&display=swap');
@import url('https://fonts.googleapis.com/css?family=Ubuntu:500&display=swap');

@font-face {
  font-family: 'Product Sans';
  font-style: normal;
  font-weight: normal;
  src: url('./assets/fonts/ProductSans-Regular.woff') format('woff');
}

@font-face {
  font-family: 'Product Sans';
  font-style: normal;
  font-weight: bold;
  src: url('./assets/fonts/ProductSans-Bold.woff') format('woff');
}

@font-face {
  font-family: 'Avenir';
  font-style: normal;
  font-weight: normal;
  src: url('./assets/fonts/Avenir-Book.woff') format('woff');
}

#app {
  font-family: 'Product-Sans-Bold', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #111111;
  width: 100vw;
/*height: 100vh; height: auto;*/
  background-color: #F8F8F8;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #00a553;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

h1 {
  color: #111111;
  font: 30px 'Product Sans', sans-serif;
  font-weight: bold;
}

h2 {
  color: #575b64;
  font: 20px 'Product Sans', sans-serif;
}

h3 {
  color: #6C7079;
  font: 17px 'Product Sans', sans-serif;
}

h4 {
  color: #6C7079;
  font: 16px 'Product Sans', sans-serif;
}

* {
  font: 14px 'Avenir', sans-serif;
  text-transform: none !important;
}

button {
  border: 1px solid #111111;
  border-radius: 20px;
  font: 16px 'Product Sans', sans-serif;
  color: #111111 !important;
  padding: 1% 3%;
}

button:hover {
  border: 1px solid #111111 !important;
  background-color: #111111 !important;
  color: #FFFFFF !important;
}

table.v-table thead th {
  font-size: 17px !important;
}

table.v-table tbody td {
  font-size: 16px !important;
}

.section-card {
  background-color: rgba(144, 146, 156, 0) !important;
}

.icon {
  color: #929292 !important;
  border: none !important;
}

.icon:hover {
  color: #929292 !important;
  background-color: rgba(85, 85, 85, 0) !important;
  border: none !important;
}
</style>
